import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Portal } from "@air/primitive-portal";
import { memo } from "react";
export const MobileFiltersContainer = /*#__PURE__*/ memo((param)=>{
    let { content, onClose } = param;
    return /*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "fixed inset-y-0 left-0 flex h-full w-screen flex-col bg-surface-1",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "flex size-full shrink-0 flex-col overflow-auto",
                    children: content
                }),
                /*#__PURE__*/ _jsx(IconButton, {
                    appearance: "ghost",
                    className: "absolute right-3 top-3",
                    color: "grey",
                    icon: Close,
                    label: "Close filters",
                    onClick: onClose,
                    size: "small"
                })
            ]
        })
    });
});
MobileFiltersContainer.displayName = "MobileFiltersContainer";
